<div class="container">
  <h2 class="text-3 font-weight-500 text-center sub_header_linkw">Remove Cache</h2>
  <p></p>
  <div class="col-sm-12">
    <select [(ngModel)]="reportType" class="form-control">
      <option value="">Select Client / Server</option>
      <option value="Client">Client</option>
      <option value="Server">Server</option>
      <option value="Both">Both</option>
    </select>
  </div>
  <div class="col-sm-12">
    <button (click)="search()" class="btn btn-primary">Submit</button>
  </div>
</div>
<div class="hero-content py-lg-5 my-lg-5">
</div>
